import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=52b5b58f&"
import script from "./error-page.vue?vue&type=script&lang=ts&"
export * from "./error-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b5b58f')) {
      api.createRecord('52b5b58f', component.options)
    } else {
      api.reload('52b5b58f', component.options)
    }
    module.hot.accept("./error-page.vue?vue&type=template&id=52b5b58f&", function () {
      api.rerender('52b5b58f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-page/error-page.vue"
export default component.exports